// Cari Hareket Raporu > Tablo Ayarları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.movementsReport.tableSettings';

export const accountMovementsTableSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Tablo ayarları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu pencereden raporda görünen sütunları yönetir, tabloyu ihtiyacınıza göre sadeleştirirsiniz.'),
  regionLabels: {
    body: t(`${G}.regions.body`, 'Sütun listesi'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Sabit sütunlar her zaman görünür'),
      text: t(`${G}.s1.text`, 'Tarih, İşlem Tipi, Cari Hesap, Tutar ve İşlemler sabit sütunlardır; gizlenemez. Anahtarları bu yüzden kapalıdır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Diğer sütunları açıp kapatın'),
      text: t(`${G}.s2.text`, 'Özelleştirilebilir sütunlardaki anahtarla yalnız ihtiyacınız olan alanları gösterin (ör. önceki / sonraki bakiye, borç, alacak, para birimi, satış ekranı).'),
      tips: [
        t(`${G}.s2.tip1`, 'Bir sütunun ne gösterdiğini görmek için yanındaki bilgi simgesinin üzerine gelin.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Değişiklikleri kaydedin'),
      text: t(`${G}.s3.text`, '"Değişiklikleri Kaydet" ayarları uygular; "İptal" değişiklikleri bırakır. Kaydettiğiniz ayarlar bu tarayıcıda saklanır ve raporu tekrar açtığınızda korunur.'),
    },
  ],
});
